export default __webpack_public_path__ + "bbc38431065c32e967dc48ef0419cb8f.png";